import React, { memo, useEffect, useState } from "react";
import { get } from "lodash";
import { Button, Col, Row } from "reactstrap";
import VideoModal from "./VideoModal";

const UnderstandingAsset = memo(function UnderstandingAsset(props) {
  // console.log(">> UnderstandingAsset", props);
  const { productDetails, investSectionRef, scrollToSection } = props;
  const [isMobile, setIsMobile] = useState(false);
  const [assetDetails, setAssetDetails] = useState(null);
  const [showVideo, setShowVideo] = useState(false);
  const videoSrc = "https://www.youtube.com/embed/w95Ku5g95kQ?autoplay=1&mute=0&rel=0&controls=1&frameborder=0&modestbranding=0&showinfo=0";

  useEffect(() => {
    setIsMobile(window.matchMedia("(max-width: 768px)").matches);
  }, []);

  useEffect(() => {
    setAssetDetails({
      title: "About " + productDetails.productName,
      logoName: productDetails.fundId + " Finserv Limited",
      logo: productDetails.descLogoUrl,

      description:
      productDetails.description,
      lastArr: [
        get(props, "assetDetails.aum", "") ? 
        {
          key: "AUM",
          value: get(props, "assetDetails.aum", "")
            ? get(props, "assetDetails.aum", "")
            : "NA",
        } : null ,
        get(props, "assetDetails.netWorth", "") ? 
        {
          key: "NetWorth",
          value: get(props, "assetDetails.netWorth", ""),
        } : null,
        get(props, "assetDetails.marketCap", "") ? 
        {
          key: "Market Cap",
          value: get(props, "assetDetails.marketCap", ""),
        } : null,
        get(props, "assetDetails.gnpa", "") ? 
        {
          key: "NNPA",
          value: get(props, "assetDetails.nnpa", ""),
        } : null,
        get(props, "assetDetails.profitAfterTax", "") ? 
        {
          key: "Profit After Tax",
          value: get(props, "assetDetails.profitAfterTax", ""),
        } : null,
          get(props, "assetDetails.debtEquityRatio", "") ? 
          {
            key: "Debt / Equity Ratio",
            value: get(props, "assetDetails.debtEquityRatio", ""),
          } : null,
      ],
    });
  }, [props]);

  const convertAmount = (val) => {
    if (val <= 0) val = 0;
    else if (val >= 10000000) {
      val = (val / 10000000).toFixed(2) + " Cr";
    } else if (val >= 100000) {
      val = (val / 100000).toFixed(2) + " Lac";
    }

    return "₹ " + val;
  };

  const handleVideoClick = () => {
    toggleVideoModal();
  }

  const toggleVideoModal = () => {
    setShowVideo(!showVideo);
  }

  return (
    <div className={"second-fold-main"} onClick={props.onClick}>
      <Row className="navi-second-fold">
        {isMobile && <div className="navi-separator" />}
        <p className="main-title mb-0">{assetDetails?.title}</p>
        <div className="second-table-container">
          <Col lg={5} sm={12} xs={12}>
            <img
              className={isMobile ? "w-80" : "w-100"}
              src={assetDetails?.logo}
              alt="logo"
            />
            {/* <div className="video-div">
              <div className="circle" onClick={() => handleVideoClick()}>
                <span class="mdi mdi-play"></span>
              </div>
            </div> */}
          </Col>
          <Col lg={7} sm={12} xs={12}>
            {!isMobile && (
              <div className="second-table">
                {assetDetails?.lastArr.map((item, index) => (
                  (item && item?.value !== "-") ?
                  <Col lg={3} key={index}>
                    <p className="font-size-17 text-muted">{item?.key}</p>
                    <p className="navi-font-22 font-weight-semi-bold">
                      {item?.value}
                    </p>
                  </Col> : null
                ))}
              </div>
            )}
            <p className="description">{assetDetails?.description}</p>
            {isMobile && (
              <div className="second-table-mob" onClick={props.onClick}>
                {assetDetails?.lastArr.map((item, index) => (
                  (item) ? 
                  <Col md={6} sm={6} xs={6} key={index}>
                    <p className="navi-font-14 text-muted mb-0">{item?.key}</p>
                    <p className="navi-font-16 font-weight-medium">
                      {item?.value}
                    </p>
                  </Col> : null
                ))}
              </div>
            )}

            {(props.assetDetails?.lenderIcons &&
                  props.assetDetails?.lenderIcons.length) ?
               ( <div className="lender-wrapper">
                  <p className="sub-title">Institutional Promoters and Lenders</p>
                  <div className="lenders">
                    {
                      props?.assetDetails?.lenderIcons.map((len) => (
                        <div className="img-wrap">
                          <img className="len-img" src={len?.imageUrl} alt=""/>
                        </div>
                      ))}
                  </div>
                </div> )
              : null 
            }

            <div className="mt-4">
              <Button
                disabled={
                  props.isTxnAllowed && props.isDisable ? false : true
                }
                onClick={() => scrollToSection(investSectionRef)}
                className="invest-btn"
              >
                Invest Now
              </Button>
            </div>
          </Col>
        </div>
      </Row>
      <VideoModal showVideo={showVideo} toggleVideoModal={toggleVideoModal} isMobile={props?.isMobile} showVideoOnly={true} src={videoSrc}/>
    </div>
  );
});

export default UnderstandingAsset;